module.exports = __webpack_public_path__ + "images/application/badge-email-any-fa788f57.png";